import { Divider, styled } from '@vw-marketing/us-components';

export const DividerBox = styled(Divider)``;
